/**
 * Whether the current user may browse colleagues' AI chats in the current
 * workspace (`incident:viewSharedChats`, PNG-500).
 *
 * Inside an incident the incident-scoped permission map is authoritative (it
 * already folds in group-level grants). Outside an incident the org-level map —
 * fetched once per selected group at app start — is used, so the gate works in
 * the global sidebar for org-level chats too. The UI gate is UX only; the
 * server enforces the same permission on every cross-user read.
 */
import { useIncidentPermissions } from 'components/IAP/hooks/incidentHooks';
import { selectIncident, useAppSelector } from 'slices/commonSelectors';

export const VIEW_SHARED_CHATS_PERMISSION = 'incident:viewSharedChats';

export const useCanViewSharedChats = (): boolean => {
  const incident = useAppSelector(selectIncident);
  const { data: incidentPermissions } = useIncidentPermissions();
  const orgPermissions = useAppSelector(
    (state) => state.app.validateRBACPermissionForActionResult
  ) as Record<string, boolean> | undefined;

  if (incident?.id) {
    return incidentPermissions?.[VIEW_SHARED_CHATS_PERMISSION] ?? false;
  }
  return !!orgPermissions?.[VIEW_SHARED_CHATS_PERMISSION];
};
